import crypto from 'crypto'

const selected = {
  // note: example structure
  // [experimentName]: {
  //   bVariantProbability: null, // keep track of the last used probability to avoid recalculation
  //   cohort: null,
  //   assignmentKey: null, // the key used for assignment (e.g. user ID or session ID)
  // },
  //
  // current experiments:
  // 'mediaService'
}

function computeAOrBVariant(assignmentKey, bVariantProbability) {
  const bProbability = parseInt(bVariantProbability, 10)

  if (Number.isNaN(bProbability) || bProbability <= 0) {
    return 'A'
  }

  if (bProbability >= 100) {
    return 'B'
  }

  if (!assignmentKey) {
    return null
  }

  const hash = crypto
    .createHash('sha256')
    .update(assignmentKey)
    .digest('hex')

  // take first 8 hex chars -> 32-bit number
  const num = parseInt(hash.slice(0, 8), 16)
  const bucket = num % 100 // 0–99

  console.log(
    'bVariantProbability:', bVariantProbability,
    'assignmentKey:', assignmentKey,
    'hash:', hash,
    'bucket:', bucket,
  )

  return bucket < bProbability ? 'B' : 'A'
}

function getAOrBVariant(experimentName, assignmentKey, bVariantProbability) {
  const cache = selected[experimentName] || {}
  if (
    cache.bVariantProbability !== bVariantProbability ||
    cache.assignmentKey !== assignmentKey ||
    cache.cohort === undefined
  ) {
    if (!selected[experimentName]) {
      selected[experimentName] = {}
    }
    selected[experimentName].bVariantProbability = bVariantProbability
    selected[experimentName].assignmentKey = assignmentKey
    selected[experimentName].cohort = computeAOrBVariant(assignmentKey, bVariantProbability)
  }

  return selected[experimentName].cohort
}

export function shouldPresentBFeature(experimentName, assignmentKey, bVariantProbability) {
  return getAOrBVariant(experimentName, assignmentKey, bVariantProbability) === 'B'
}
